import React from "react";
import { Sparkles } from "lucide-react";

const ContactHero = () => {
  const features = [
    "Personalized demo using your actual practice workflow",
    "Response within 1 business day",
    "No obligation — just expert guidance on smile simulation for your specialty",
    "See real AI smile previews live",
  ];

  return (
    <section className="relative pt-32 pb-16 px-3 sm:px-4 lg:px-6 flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Top Badge */}
      <div className="inline-flex items-center gap-2 rounded-full bg-blue-100/50 backdrop-blur-sm border border-blue-200 px-4 py-1.5 mb-8 z-10 animate-fade-in-scale">
        <Sparkles className="h-4 w-4 text-blue-500 fill-blue-500" />
        <span className="text-xs sm:text-sm font-bold text-slate-800">
          Book a Personalized AI Smile Simulation Demo
        </span>
      </div>

      {/* Heading */}
      <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 max-w-4xl leading-[1.1] animate-fade-in-up delay-100">
        Request a Demo of <br className="hidden md:block" />
        SmileReveal™ AI Smile Simulation
      </h1>

      {/* Description */}
      <p className="text-lg md:text-xl text-slate-600 mb-12 max-w-3xl leading-relaxed animate-fade-in-up delay-200">
        See how SmileReveal™ can help your dental practice boost case acceptance
        to 60%+ with AI-powered smile simulation. Get a personalized walkthrough
        of how it works with your real patient workflow — for implants, veneers,
        All-on-X, or cosmetic cases.
      </p>

      {/* Feature Pills */}
      <div className="flex flex-wrap justify-center gap-3 max-w-4xl pb-10 animate-fade-in-up delay-300">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex items-center gap-2.5 px-5 py-2.5 bg-white/90 border border-slate-100 rounded-full shadow-sm hover:shadow-md transition-shadow duration-300 animate-fade-in-scale"
            style={{ animationDelay: `${380 + index * 90}ms` }}
          >
            <div className="w-2 h-2 rounded-full bg-blue-500" />
            <span className="text-sm md:text-base font-semibold text-slate-700 whitespace-nowrap">
              {feature}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContactHero;
